module.exports = __webpack_public_path__ + "img/report.11139bf8.png";